import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureAttribution, trackLandingEvent } from '../services/analytics';

const trackedPages: Record<string, string> = {
  '/': 'home',
  '/pricing': 'pricing',
  '/mySubscription': 'my-subscription',
  '/login': 'login',
  '/solutions': 'solutions-index',
  '/subscription-success': 'subscription-success',
  '/subscription-canceled': 'subscription-canceled'
};

const resolvePageName = (pathname: string) => {
  if (trackedPages[pathname]) {
    return trackedPages[pathname];
  }

  if (pathname.startsWith('/solutions/')) {
    return 'solutions-article';
  }

  return null;
};

export const useFirebaseAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    captureAttribution();

    const pathname = location.pathname;
    const pageName = resolvePageName(pathname);

    trackLandingEvent('page_view', {
      page_path: pathname,
      page_location: window.location.href,
      page_title: document.title,
      route_group: pageName || 'other'
    });

    if (pageName) {
      trackLandingEvent('page_visit', {
        page_name: pageName
      });
    }
  }, [location.pathname, location.search]);
};

export default useFirebaseAnalytics;
